import { inject } from 'tsyringe'
import { VueRouter } from '~/utils/nuxt3-migration'
import { containerScoped } from '~/decorators/dependency-container'
import { DealerSiteConfigFactoryParams } from '~/models/classified/types'
import { StoreWithRootState } from '~/store/types'
import { SearchConfig } from '~/models/search/config'
import {
  storeToken,
  vueRouterToken
} from '~/constants/dependency-injection/tokens'

@containerScoped()
export default class DealerSiteConfigService {
  constructor(
    @inject(storeToken) private store: StoreWithRootState,
    @inject(vueRouterToken) private router: VueRouter
  ) {}

  createSearchConfig(): SearchConfig {
    const { store } = this
    const { websiteId } = store.state.dealers.site
    const { searchArgs } = store.getters['dealers/site/activePage']
    const getTemplateOption = store.getters['dealers/site/getTemplateOption']
    const defaultViewType = getTemplateOption('classifieds_default_layout')
    const currentRoute = { ...this.router.currentRoute }
    if (process.server && currentRoute.query) {
      delete currentRoute.query.lang
    }

    return DealerSiteConfigService.createSearchConfigFromParams({
      searchArgs,
      defaultViewType,
      websiteId
    })
  }

  private static createSearchConfigFromParams({
    searchArgs,
    defaultViewType,
    websiteId
  }: DealerSiteConfigFactoryParams): SearchConfig {
    return {
      rootParams: searchArgs,
      settings: {
        searchName: 'dsite-search',
        searchbar: {
          autocompleteEndpoint: '/api/classifieds/dsite/query/',
          usesNuxtLinks: true
        },
        forceAwait: true,
        viewType: {
          defaultViewTypeDesktop: defaultViewType,
          defaultViewTypeMobile: defaultViewType
        },
        sellerWebsiteId: websiteId,
        omitEmptyMakes: true,
        displayAds: false,
        isDealerSiteSearch: true
      }
    }
  }
}
